<template>
  <div class="tooltip">
    <v-tooltip
      bottom
      :open-on-hover="false"
      :open-on-click="true"
      nudge-left="-175px"
      nudge-top="30px"
      max-width="300px"
      v-bind="$attrs"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click="on.click"
          class="tooltip__activator"
        >
          <QuestionIcon />
        </v-btn>
      </template>

      <div class="tooltip__title">
        <slot name="title"></slot>
      </div>

      <div class="tooltip__body">
        <slot></slot>
      </div>

    </v-tooltip>
  </div>
</template>

<script>
import QuestionIcon from "@/components/icons/QuestionIconGreen";

// :open-on-click fix
// https://github.com/vuetifyjs/vuetify/issues/11236

export default {
  name: 'ToolTip',
  props: {
  },
  components:{
    QuestionIcon
  },
  data: function(){
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="scss">
  .tooltip {
    &__title {
      color: map-get($green, 'darken-1');
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: $spacer/2;
    }

    &__body {
      line-height: 18px;
    }
  }
</style>

<style lang="scss">
  /* Override element style */
  .v-tooltip__content {
    opacity: 1 !important;
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.32);
  }

  /* Override default paragraph margin */
  .tooltip {
    &__body {
      p {
        margin-bottom: $spacer/2;
      }
    }
  }
</style>
